export default __webpack_public_path__ + "static/media/3.8e42c3dc.jpg";